<template>
  <div>
    <el-card>
      <!--基础信息-->
      <div style="font-size: 14px; color: #606266">
        <span>Status：{{ formData.appraisalBillStatusName }}</span>
        <el-divider direction="vertical"></el-divider>
        <span>
          Create：{{ formData.createByName }} at
          {{ formData.createDate }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span>
          Modify：{{ formData.modifyByName }} at
          {{ formData.modifyDate }}
        </span>
      </div>
      <div class="mt-2">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form ref="formData" :model="formData" :rules="rules">
              <el-row :gutter="20">
                <el-col
                  :sm="{ span: 24 }"
                  :md="{ span: 12 }"
                  :lg="{ span: 12 }"
                >
                  <el-form-item
                    :label="$l('table-label-pjname') || '评价表名称'"
                    prop="appraisalBillName"
                  >
                    <el-input
                      v-model="formData.appraisalBillName"
                      maxlength="50"
                      placeholder="请输入"
                      :disabled="isViewDisabled"
                      clearable
                      size="medium"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
        <el-button-group v-show="type === 'edit'">
          <el-button type="primary" size="mini" @click="chooseGroupDialogShow">
            <i class="fa fa-plus"></i>
            {{ $l('btn_addScoreGroup') || '添加评分分组' }}
          </el-button>
        </el-button-group>
        <el-row :gutter="20">
          <el-col :span="24">
            <vxe-grid
              auto-resize
              class="mt-2"
              border
              round
              resizable
              :tree-config="treeConfig"
              :columns="tableColumn"
              :data="formData.detailJson"
              :height="height"
            >
              <template v-slot:operate="{ row }">
                <div
                  style="display: flex;justify-content: center"
                  v-show="row.level === '1'"
                >
                  <b-button-group>
                    <b-button
                      :disabled="isViewDisabled"
                      @click="delGroup(row)"
                      variant="outline-secondary"
                      size="sm"
                    >
                      <b-icon-trash-fill></b-icon-trash-fill>
                    </b-button>
                  </b-button-group>
                </div>
              </template>
            </vxe-grid>
          </el-col>
        </el-row>
      </div>
      <div class="d2-mt">
        <el-row>
          <el-col :span="8">
            <el-button
              @click="save"
              type="primary"
              size="small"
              v-if="!isViewDisabled"
              >{{ $l('INDEX.btn_save') || '保存' }}</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-card>
    <!--选择评分组弹框-->
    <el-dialog
      ref="chooseGroupDialog"
      :title="$l('label_selectScoringGroup') || '选择评分分组'"
      :visible.sync="chooseGroupDialogVisible"
      :before-close="chooseGroupDialogCancel"
      :close-on-click-modal="false"
      width="950px"
    >
      <choose-appraisal-group
        ref="chooseGroupForm"
        @chooseGroupAdd="chooseGroupAdd"
      ></choose-appraisal-group>
    </el-dialog>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import validate from '@/libs/util.validate'
import { mapActions } from 'vuex'
export default {
  mixins: [TableAutoHeight],
  components: {
    ChooseAppraisalGroup: () =>
      import('@/views/digital/components/choose-appraisal-group'),
  },
  data() {
    return {
      pageHeader: '',
      isViewDisabled: false,
      dialogVisible: false,
      chooseGroupDialogVisible: false,
      type: '',
      formData: {
        appraisalBillCode: '',
        appraisalBillName: '',
        appraisalBillStatus: '',
        appraisalBillStatusName: '',
        createByName: '',
        createDate: '',
        modifyByName: '',
        modifyDate: '',
        detailJson: [],
      },
      treeConfig: {
        children: 'listItem',
        expandAll: false,
      },
      tableColumn: [
        { type: 'seq', width: 50 },
        {
          field: 'itemName',
          title: this.$l('label_nameOfScoringGroup') || '评分组名称',
          width: 160,
          treeNode: true,
        },
        {
          field: 'itemNameEn',
          title: this.$l('label_nameOfScoringGroupEn') || '评分组名称英文',
          minWidth: 160,
        },
        {
          field: 'itemDesc',
          title: this.$l('label_group_description') || '评分组说明',
          minWidth: 200,
        },
        {
          field: 'score',
          title: this.$l('label_totalScore') || '总分',
          width: 80,
          align: 'center',
        },
        {
          title: this.$l('table-label-operation') || '操作',
          width: 80,
          slots: { default: 'operate' },
        },
      ],
      rules: {
        appraisalBillName: [
          {
            required: true,
            message: this.$l('tips_petnotef') || '请输入评价表名称',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    height() {
      return this.tableHeight - 108 < 400 ? 400 : this.tableHeight - 108
    },
  },
  mounted() {
    let type = this.$route.params.pageType
    let appraisalBillCode = this.$route.params.appraisalBillCode
    this.init(type, appraisalBillCode)
  },
  activated() {
    let type = this.$route.params.pageType
    let appraisalBillCode = this.$route.params.appraisalBillCode
    this.init(type, appraisalBillCode)
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    init(type, appraisalBillCode) {
      this.reset()
      this.type = type
      console.log('appraisalBillCode前', appraisalBillCode)
      if (this.type === 'edit') {
        console.log('appraisalBillCodeEdit', appraisalBillCode)

        this.pageHeader = this.$l('tips_edit') || '修改'
        this.isViewDisabled = false
        this.detailLoad(appraisalBillCode)
      } else if (this.type === 'detail') {
        this.pageHeader = this.$l('tips_view') || '详情'
        this.isViewDisabled = true
        this.detailLoad(appraisalBillCode)
      } else {
        this.pageHeader = this.$l('tips_add') || '新增'
        this.isViewDisabled = false
        this.formData.appraisalBillStatus = 'Y'
        this.formData.appraisalBillStatusName = '有效'
      }
    },
    detailLoad(val) {
      let param = { appraisalBillCode: val }
      this.$api.scmAppraisalBillDetailApi(param).then((res) => {
        this.formData = res.body
      })
    },
    save() {
      const form = this.$refs.formData
      validate.formValidate([form], (valid) => {
        if (valid) {
          this.$api.scmAppraisalBillSaveApi(this.formData).then((res) => {
            if (this.type === 'add') {
              this.$message({
                showClose: true,
                message: this.$l('INDEX.tips_save_ok') || '保存成功',
                type: 'success',
              })
              // 新增页面保存后不返回
              this.init('edit', res.body)
            } else {
              this.saveOkQuestion()
            }
          })
        }
      })
    },
    saveOkQuestion() {
      this.$alert(
        this.$l('INDEX.tips_save_ok') || '保存成功',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          confirmButtonText: '确定',
          callback: () => {
            this.closeCurPage()
          },
        }
      )
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
    chooseGroupDialogShow() {
      let groupCodeList = []
      if (this.formData.detailJson && this.formData.detailJson.length > 0) {
        this.formData.detailJson.forEach((item) => {
          groupCodeList.push(item.groupCode)
        })
      }
      setTimeout(() => {
        // 调用组件表单加载方法
        this.$refs.chooseGroupForm.load(groupCodeList)
      }, 0)
      this.chooseGroupDialogVisible = true
    },
    chooseGroupDialogCancel() {
      this.chooseGroupDialogVisible = false
    },
    chooseGroupAdd(data) {
      // 保存勾选的评分分组
      if (!data || data.length < 1) {
        this.$message.warning(this.$l('INDEX.tips_select_data') || '请选择数据')
        return
      }
      this.chooseGroupDialogVisible = false
      let appraisalGroupCodeList = []
      for (let i = 0; i < data.length; i++) {
        appraisalGroupCodeList.push(data[i].appraisalGroupCode)
      }
      let params = {
        appraisalBillCode: this.formData.appraisalBillCode,
        appraisalGroupCodeList: appraisalGroupCodeList,
      }
      this.$api.scmAppraisalBillDetailAddApi(params).then(() => {
        this.$message.success(this.$l('INDEX.tips_save_ok') || '添加成功')
        this.init('edit', this.formData.appraisalBillCode)
      })
    },
    delGroup(row) {
      this.$confirm(
        this.$l('INDEX.tips_question_delete') || '是否删除？',
        this.$l('INDEX.tips_question_title') || '提示',
        {
          confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.$api
            .scmAppraisalBillDetailDelApi({
              appraisalBillDetailCode: row.billDetailCode,
            })
            .then(() => {
              this.$message.success(
                this.$l('INDEX.tips_delete_ok') || '删除成功'
              ),
                this.init(this.type, this.formData.appraisalBillCode)
            })
        })
        .catch(() => {})
    },
    reset() {
      this.pageHeader = ''
      this.isViewDisabled = false
      this.type = ''
      this.formData = {
        appraisalBillCode: '',
        appraisalBillName: '',
        appraisalBillStatus: '',
        appraisalBillStatusName: '',
        createByName: '',
        createDate: '',
        modifyByName: '',
        modifyDate: '',
        detailJson: [],
      }
      this.$refs.formData.resetFields()
    },
  },
}
</script>
